import React, { useState } from 'react';

import { computeCategories, computeOrderTotal } from '../../helpers/orders';
import { formatMoney } from '../../helpers/formatters';
import { LoadingComponent } from '../common/ui/LoadingComponent';

export const CartSummary = ({ items, onCompleteOrder, onClearOrder, onSearchGifts }) => {
    const [isProcessing, setIsProcessing] = useState(false);
    const orderCategories = computeCategories(items);
    const orderTotal = computeOrderTotal(items);

    if (isProcessing) {
        return (
            <div className="card mt-3 mb-3">
                <div className="card-body mt-3">
                    <LoadingComponent text="Processing..." />
                </div>
            </div>
        );
    }

    const handleCompleteOrder = async () => {
        setIsProcessing(true);
        await onCompleteOrder(items);
        setIsProcessing(false);
    };

    return (
        <React.Fragment>
            <ul className="list-group mt-3 mb-3">
                <li className="list-group-item">
                    <div className="row">
                        <div className="col-12">
                            <h3 className="text-center h4">Cart summary</h3>
                        </div>
                    </div>
                </li>
                {orderCategories.map((category, index) => (
                    <li
                        key={index}
                        className="list-group-item d-flex justify-content-between align-items-start">
                        <div className="ms-2 me-auto">
                            <div className="text-muted">{category.name}</div>
                        </div>
                        <span className="badge bg-dark rounded-pill">{category.quantity}</span>
                    </li>
                ))}
                <li className="list-group-item">
                    <div className="row">
                        <div className="col-12">
                            <p className="text-black-50 text-end fw-bold h5">Total cost</p>
                        </div>
                        <div className="col-12">
                            <p className="text-success text-end fw-bold h4">
                                {formatMoney(orderTotal)}
                            </p>
                        </div>
                    </div>
                </li>
            </ul>
            <div className="d-grid">
                <button onClick={handleCompleteOrder} className="btn btn-primary mb-3">
                    Complete order
                </button>
            </div>
            {onSearchGifts && (
                <div className="d-grid">
                    <button onClick={onSearchGifts} className="btn btn-outline-primary mb-3">
                        Search gift
                    </button>
                </div>
            )}
            <div className="d-grid">
                <button onClick={onClearOrder} className="btn btn-outline-secondary mb-3">
                    Clear order
                </button>
            </div>
        </React.Fragment>
    );
};
